import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import * as fromRouter from '@ngrx/router-store';

export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
    data: any;
}

export const reducer = fromRouter.routerReducer;

@Injectable()
export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
    public serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const { url } = routerState;
        const { queryParams } = routerState.root;

        let state: ActivatedRouteSnapshot = routerState.root;
        while (state.firstChild) {
            state = state.firstChild;
        }

        const { params, data } = state;

        return { url, queryParams, params, data };
    }
}
